module.exports = __webpack_public_path__ + "img/agentstudio-1.bda7d331.jpg";